import { Injectable } from '@angular/core';
import { CanLoad } from '@angular/router';
import { SessionService } from '../services/session.service';

@Injectable({
  providedIn: 'root'
})
export class SessionGuard implements CanLoad {
  constructor(private session: SessionService) {}

  canLoad() {
    return this.session.loggedIn$;
  }
}
